import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDrop } from 'react-dnd';
import { List, ListSubheader } from '@mui/material';
import SKDColumnItem from './columnItem';
import itemTypes from '../itemTypes';
import { columnsPropType } from '../../hooks';
import GroupEditor, { useGroupEditor } from '../groupEditor';

function SKDColumnsList({
  columns, activeColumn, onClick, onDblClick, onDragEnd, onSubColumnClick, onChangeHierarchy, onSwapSubcolumns,
}) {
  const [padded, setPadded] = useState(null);
  const onDragEndHandler = useCallback(
    (item) => {
      onDragEnd(item, padded);
    },
    [onDragEnd, padded],
  );
  const [{
    isOver, isOverCurrent, didDrop,
  }, ref] = useDrop({
    accept: [itemTypes.availableField, itemTypes.column],
    drop: (item) => onDragEndHandler(item),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      isOverCurrent: monitor.isOver({ shallow: true }),
      // CanDrop: monitor.canDrop(),
      didDrop: monitor.didDrop(),
    }),
  });

  const setPaddedHandler = useCallback(
    (e) => setPadded(e),
    [setPadded],
  );

  useEffect(() => {
    if ((!isOver && !isOverCurrent && !didDrop) || (isOver && isOverCurrent && !didDrop)) {
      setPadded(null);
    }
  }, [didDrop, isOver, isOverCurrent]);

  const {
    ctxMenu, ctxMenuopened, onCloseCtxMenu, onCtxMenu, onDeleteItem, editDialog, onEditItem,
    onCloseEditDialog, subItems, onRemoveSubGroup, onUpSubgroup, onDownSubgroup,
  } = useGroupEditor({
    onDelete: onDblClick, items: columns, onRemoveSubItem: onSubColumnClick, onSwap: onSwapSubcolumns,
  });

  return (
    <List
      sx={{
        border: 1, borderColor: 'divider', borderRadius: 2, overflow: 'auto', flex: '1 1 auto', width: 50,
      }}
      ref={ref}
      component="nav"
      subheader={(
        <ListSubheader component="div" sx={{ bgcolor: 'grey.100' }}>
          Обрані групування
        </ListSubheader>
      )}
      dense
      disablePadding
    >
      {columns.map((f) => (
        <SKDColumnItem
          subcolumns={f.items}
          name={f.name}
          key={f.name}
          onClick={onClick}
          onDblClick={onDblClick}
          onSubColumnClick={onSubColumnClick}
          active={activeColumn === f.name}
          onHover={setPaddedHandler}
          padded={padded === f.name}
          onChangeHierarchy={onChangeHierarchy}
          onCtxMenu={onCtxMenu}
        />
      ))}
      <GroupEditor
        onDeleteItem={onDeleteItem}
        ctxMenuopened={ctxMenuopened}
        ctxMenu={ctxMenu}
        onCloseCtxMenu={onCloseCtxMenu}
        editDialog={editDialog}
        onEditItem={onEditItem}
        onCloseEditDialog={onCloseEditDialog}
        subItems={subItems}
        onRemoveSubGroup={onRemoveSubGroup}
        onUpSubgroup={onUpSubgroup}
        onDownSubgroup={onDownSubgroup}
      />
    </List>
  );
}

SKDColumnsList.propTypes = {
  columns: columnsPropType.isRequired,
  onClick: PropTypes.func.isRequired,
  onSubColumnClick: PropTypes.func.isRequired,
  onDblClick: PropTypes.func.isRequired,
  activeColumn: PropTypes.string,
  onDragEnd: PropTypes.func.isRequired,
  onChangeHierarchy: PropTypes.func.isRequired,
  onSwapSubcolumns: PropTypes.func.isRequired,
};

SKDColumnsList.defaultProps = {
  activeColumn: null,
};
export default SKDColumnsList;
